import { Directive, inject, input, OnInit } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { HisNumberValidators } from '../validator/his-number-validators';
import { HisValidatorAndMessage } from '../validator/his-validator-and-message';
import { HisUiService } from './../service/base/his-ui.service';

@Directive( {
    selector: '[hisInteger],[hisIntegerMin],[hisIntegerMax]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: HisIntegerValidatorDirective,
            multi: true
        }
    ],
    standalone: false
})
export class HisIntegerValidatorDirective implements Validator, OnInit {
    private validator: Validator;
    private uiService = inject( HisUiService );

    public readonly hisIntegerMin = input<number>();
    public readonly hisIntegerMax = input<number>();

    ngOnInit() {
        const validator = new HisValidatorAndMessage( 'integer', HisNumberValidators.isInteger({ min: this.hisIntegerMin(), max: this.hisIntegerMax() }), this.uiService );
        validator.messageKey = 'jakarta.faces.validator.LongRangeValidator.TYPE';
        validator.paramNames = ['input'];
        this.validator = validator;
    }

    validate( control: AbstractControl ): ValidationErrors | null {
        return this.validator.validate( control );
    }
}
